import { gql } from '@apollo/client';

export const UpdateColorsStore = gql`
mutation UpdateColorsStore($idStore: ID!, $content: contentColors!) {
  updateColorsStore(idStore: $idStore, content: $content) {
    status
  }
}
`;